import React from 'react';
import GeneralDashboar from '../DashBoard/GeneralDashboard/GeneralDashboar';
import Header from '../Header';

const DashboardPage = () => {
    return (
        <>
            <Header position="relative" />
            <GeneralDashboar />
        </>
    );
};

export default DashboardPage;